
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Svg, Path } from 'react-native-svg';

interface PageHeaderProps {
  title: string;
  onBack: () => void;
  showBackButton?: boolean;
  rightComponent?: React.ReactNode;
  backgroundColor?: string;
}

export default function PageHeader({ 
  title, 
  onBack, 
  showBackButton = true, 
  rightComponent,
  backgroundColor = '#FFFFFF'
}: PageHeaderProps) {
  return (
    <View style={[styles.header, { backgroundColor }]}>
      {showBackButton ? (
        <TouchableOpacity onPress={onBack} style={styles.backButton}>
          <Svg width="25" height="24" viewBox="0 0 25 24" fill="none">
            <Path d="M16.5859 19L9.58594 12L16.5859 5" stroke="#151515" strokeWidth="2" strokeLinecap="square" />
          </Svg>
        </TouchableOpacity>
      ) : (
        <View style={styles.placeholder} />
      )}
      
      <Text style={styles.headerTitle}>{title}</Text>
      
      {rightComponent ? rightComponent : <View style={styles.placeholder} />}
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    paddingTop: 16,
    paddingBottom: 16,
    borderBottomWidth: 0,
  },
  backButton: {
    padding: 4,
  },
  headerTitle: {
    fontSize: 14,
    fontFamily: 'Inter_700Bold',
    color: '#151515',
    textAlign: 'center',
    flex: 1,
  },
  placeholder: {
    width: 24,
  },
});
